export default {"src":"/_next/static/media/publicnouns-logo.1825d630.svg","height":70,"width":190,"blurWidth":0,"blurHeight":0};